import React from "react";
import {
  Divider,
  makeStyles,
  Tab,
  TabList,
  tokens,
} from "@fluentui/react-components";
import prodLogo from "../logo/ATA_blue.png";
import { useTranslation } from "react-i18next";
const useStyles = makeStyles({
  navContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: `${tokens.spacingVerticalXXL} 104px`,
    gap: tokens.spacingVerticalMNudge,
    "@media (max-width: 600px)": {
      marginLeft: tokens.spacingHorizontalXXL,
      marginRight: tokens.spacingHorizontalXXL,
    },
  },
  logo: {
    height: "40px",
    width: "auto",
  },
  tab: {
    gap: tokens.spacingHorizontalS,
    paddingTop: tokens.spacingVerticalM,
    paddingBottom: tokens.spacingVerticalM,
    fontWeight: tokens.fontWeightBold,
    fontSize: tokens.fontSizeHero700,
    lineHeight: tokens.lineHeightBase600,
  },
  divider: {
    "::before": {
      borderTopWidth: tokens.strokeWidthThick,
    },
    "::after": {
      borderTopWidth: tokens.strokeWidthThick,
    },
  },
});
export const Header = () => {
  const styles = useStyles();
  const { t } = useTranslation();
  const ataHomePageUrl = process.env.REACT_APP_ATA_HOMEPAGE_URL;
  return (
    <div>
      <div className={styles.navContainer}>
        <img src={prodLogo} alt="Företagslogotyp" className={styles.logo} />
        <TabList size="large">
          <Tab
            value="tab1"
            className={styles.tab}
            onClick={() => (window.location.href = ataHomePageUrl)}
          >
            {t("button.backToWebsite")}
          </Tab>
        </TabList>
      </div>
      <Divider appearance="brand" className={styles.divider} />
    </div>
  );
};
